import { Card, CardContent, Typography } from '@mui/material'
import React from 'react'
import { Link } from 'react-router-dom'
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import ReceiptIcon from '@mui/icons-material/Receipt';
import PostAddIcon from '@mui/icons-material/PostAdd'
import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt'
import TransformIcon from '@material-ui/icons/Transform';
import InventoryIcon from '@mui/icons-material/Inventory';
import AssessmentIcon from '@mui/icons-material/Assessment';
import Container from '@mui/material/Container';
import SettingsIcon from '@mui/icons-material/Settings';
import Grid from '@mui/material/Grid';

const Dashboard = ({user}) => {
  return (
    <Container maxWidth="false" disableGutters sx={{height: "92vh", width: "100vw"}}>
        <Grid container spacing={2}>
            <Grid item xs={4}>
                <Link to="/pos" style={{ textDecoration: 'none', width: "100%"}}>
                    <Card sx={{ margin: "5px" }}>
                        <CardContent >
                            <center><AddShoppingCartIcon style={{ color:"#1776d1", fontSize: 150 }}/></center>
                            <Typography gutterBottom variant="h5" component="div" align="center" style={{ color:"#1776d1", fontSize: 38, textDecoration: 'none' }}>
                                POS
                            </Typography>
                        </CardContent>      
                    </Card>
                </Link>
            </Grid>
            <Grid item xs={4}>
                <Link to="/poskeyboard" style={{ textDecoration: 'none', width: "100%"}}>
                    <Card sx={{ margin: "5px" }}>
                        <CardContent >
                            <center><AddShoppingCartIcon style={{ color:"#1776d1", fontSize: 150 }}/></center>
                            <Typography gutterBottom variant="h5" component="div" align="center" style={{ color:"#1776d1", fontSize: 38, textDecoration: 'none' }}>
                                POS KEYBOARD
                            </Typography>
                        </CardContent>      
                    </Card>
                </Link>
            </Grid>
            <Grid item xs={4}>
                <Link to="/invoice" style={{ textDecoration: 'none', width: "100%" }}>
                    <Card sx={{ margin: "5px" }}>
                        <CardContent>
                            <center><ReceiptIcon style={{ color:"#1776d1", fontSize: 150 }}/></center>
                            <Typography gutterBottom variant="h5" component="div" align="center" style={{ color:"#1776d1", fontSize: 38, textDecoration: 'none' }}>
                                INVOICE
                            </Typography>
                        </CardContent>      
                    </Card>
                </Link>
            </Grid>
            {user.isAdmin && <Grid item xs={4}>
            <Link to="/reports" style={{ textDecoration: 'none', width: "100%" }}>
                <Card sx={{ margin: "5px" }}>
                    <CardContent>
                        <center><AssessmentIcon style={{ color:"#1776d1", fontSize: 150 }}/></center>
                        <Typography gutterBottom variant="h5" component="div" align="center" style={{ color:"#1776d1", fontSize: 38, textDecoration: 'none' }}>
                            REPORT
                        </Typography>
                    </CardContent>      
                </Card>
            </Link>
            </Grid>}
            {user.isAdmin && <Grid item xs={4}>
            <Link to="/items" style={{ textDecoration: 'none', width: "100%" }}>
                <Card sx={{ margin: "5px" }}>
                    <CardContent>
                        <center><PostAddIcon style={{ color:"#1776d1", fontSize: 150 }}/></center>
                        <Typography gutterBottom variant="h5" component="div" align="center" style={{ color:"#1776d1", fontSize: 38, textDecoration: 'none' }}>
                            ITEM
                        </Typography>
                    </CardContent>      
                </Card>
            </Link>
            </Grid>}
            {user.isAdmin && <Grid item xs={4}>
            <Link to="/users" style={{ textDecoration: 'none', width: "100%" }}>
                <Card sx={{ margin: "5px" }}>
                    <CardContent>
                        <center><PersonAddAltIcon style={{ color:"#1776d1", fontSize: 150 }}/></center>
                        <Typography gutterBottom variant="h5" component="div" align="center" style={{ color:"#1776d1", fontSize: 38, textDecoration: 'none' }}>
                            USER
                        </Typography>
                    </CardContent>      
                </Card>
            </Link>
            </Grid>}
            <Grid item xs={4}>
                <Link to="/transfer" style={{ textDecoration: 'none', width: "100%" }}>
                <Card sx={{ margin: "5px" }}>
                    <CardContent>
                        <center><TransformIcon style={{ color:"#1776d1", fontSize: 150 }}/></center>
                        <Typography gutterBottom variant="h5" component="div" align="center" style={{ color:"#1776d1", fontSize: 38, textDecoration: 'none' }}>
                            TRANSFER
                        </Typography>
                    </CardContent>      
                </Card>
            </Link>
            </Grid>
            <Grid item xs={4}>
            <Link to="/eodstock" style={{ textDecoration: 'none', width: "100%" }}>
                <Card sx={{ margin: "5px" }}>
                    <CardContent>
                        <center><InventoryIcon style={{ color:"#1776d1", fontSize: 150 }}/></center>
                        <Typography gutterBottom variant="h5" component="div" align="center" style={{ color:"#1776d1", fontSize: 38, textDecoration: 'none' }}>
                            STOCK LEDGER
                        </Typography>
                    </CardContent>      
                </Card>
            </Link>
            </Grid>
            {user.isAdmin && <Grid item xs={4}>
            <Link to="/openingstock" style={{ textDecoration: 'none', width: "100%" }}>
                <Card sx={{ margin: "5px" }}>
                    <CardContent>
                        <center><InventoryIcon style={{ color:"#1776d1", fontSize: 150 }}/></center>
                        <Typography gutterBottom variant="h5" component="div" align="center" style={{ color:"#1776d1", fontSize: 38, textDecoration: 'none' }}>
                            STOCK MASTER
                        </Typography>
                    </CardContent>      
                </Card>
            </Link>
            </Grid>}
            {user.isAdmin && <Grid item xs={4}>
            <Link to="/settings" style={{ textDecoration: 'none', width: "100%" }}>
                <Card sx={{ margin: "5px" }}>
                    <CardContent>
                        <center><SettingsIcon style={{ color:"#1776d1", fontSize: 150 }}/></center>
                        <Typography gutterBottom variant="h5" component="div" align="center" style={{ color:"#1776d1", fontSize: 38, textDecoration: 'none' }}>
                            SETTINGS
                        </Typography>
                    </CardContent>      
                </Card>
            </Link>
            </Grid>}
        </Grid>
    </Container>
  )
}

export default Dashboard
